import React, { useEffect, useState } from 'react';
import { ReactComponent as Pencil } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import Button from 'components/button';
import { Input } from 'antd';
import { Select } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupData, getGroups, getPrivileges, getPrivilegesByGroup, getUserData } from 'store/adminPanel/actions';

const ViewModal = ({ isVisible, setVisible, groupId, editedPriv, setEditedPriv }) => {
    const dispatch = useDispatch();

    const group = useSelector((state => state.adminPanel.selectedGroup));
    const [groupID, setGroupID] = useState(group?.id);
    const [groupName, setGroupName] = useState(group?.name);
    const [groupType, setGroupType] = useState(group?.type);
    const [groupPrivileges, setGroupPrivileges] = useState([]);

    useEffect(() => {
        if(groupId){
            dispatch(getGroupData(groupId));
        }
    }, [groupId]);

    // console.log("privileges:",privileges);
    // console.log("id:",groupID);
    useEffect(()=>{
        if(groupID){
            getPrivilegesByGroup(
                groupID,
                callback => {
                    if(callback){
                        // console.log("callback:",callback.map(item=>item.name));
                        setGroupPrivileges(callback.map(item=>item.name));
                    }
                }
            )
            setEditedPriv(false);
        }
    },[groupID,editedPriv])

    useEffect(()=>{
        setGroupID(group?.id);
        setGroupName(group?.name);
        setGroupType(group?.type);
        // setGroupPrivileges()
    },[group]);

    return (
      <Modal
        isVisible={isVisible}
        // Icon={Pencil}
        onCancel={() => setVisible(false)}
        // onOk={()=> handleOk()}
        // title={<h1 style={{color:"#2d97e9", marginTop:"0.563rem", marginLeft:"1.875rem"}}>Edit group</h1>}
        width={817}
        footer={[
            <Button
              label={'Close'}
              type={'default'}
              onClick={() => setVisible(false)}
            />,
          ]}
          className={'invalid-modal'}
      >
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Group ID</span>
            <Input disabled style={{height:"40px"}} value={groupID}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Name</span>
            <Input disabled style={{height:"40px"}} value={groupName}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Type</span>
            <Input disabled style={{height:"40px"}} value={groupType}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Privileges</span>
            <Select
                disabled
                showSearch={false}
                size="small"
                mode="multiple"
                value={groupPrivileges}
                placeholder="Select a group"
            />
        </div>
      </Modal>
    );
  };
  
  export default ViewModal;